import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'ld-maintenance-page',
  imports: [MatIconModule, TranslocoDirective],
  templateUrl: './maintenance-page.component.html',
  styleUrl: './maintenance-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenancePageComponent {
  private readonly transloco = inject(TranslocoService);

  readonly message = input<string>('');

  readonly expectedEndTime = input<string>('');

  protected readonly defaultMessage = this.transloco.translate('authMaintenanceDefaultMessage');

  protected getFormattedEndTime(): string {
    const endTime = this.expectedEndTime();
    if (!endTime) return '';

    try {
      const date = new Date(endTime);
      return date.toLocaleString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    } catch {
      return endTime;
    }
  }

  protected onRetry(): void {
    window.location.reload();
  }
}
